// extracted by mini-css-extract-plugin
export default {"yellowbackground":"jobs_yellowbackground__6IFnC","boldfont":"jobs_boldfont__gjQII","deletebutton":"jobs_deletebutton__3yc9E"};